<template>
  <router-link
    v-if="book.ad_client == null"
    class="RwvBookTile"
    :to="{name: 'book', params: { slug: book.slug }}">

    <b-img :src="book.previewImage" :title="book.title" :alt="book.title"/>
  </router-link>
  <InFeedAdsense
    class="RwvBookTile adTile"
    v-else
    :data-ad-layout-key="book.layout_key"
    :data-ad-client="book.ad_client"
    :data-ad-slot="book.ad_slot">
  </InFeedAdsense>
</template>

<script>
export default {
  name: "RwvBookTile",
  props: {
    book: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.RwvBookTile {
  width: 195px;
  min-height: 250px;
  max-height: 275px;
  max-width: 390px;
  float: left;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
